import { Data_getInstance2muox7fllvisv as Data_getInstance } from './adapter/SavePairAssignmentsMutation_ResponseAdapter.mjs';
import { getBooleanHashCode1bbj3u6b3v0a7 as getBooleanHashCode } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { obj2vqjd1bjrpmyg as obj } from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Adapters.mjs';
import { Companion_getInstance8d9dd8emdwrf as Companion_getInstance } from './type/Mutation.mjs';
import { Builder320ghmibyd2no as Builder } from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/CompiledGraphQL.mjs';
import { SavePairAssignmentsMutationSelections_getInstanceppfg5wpx76tv as SavePairAssignmentsMutationSelections_getInstance } from './selections/SavePairAssignmentsMutationSelections.mjs';
import { SavePairAssignmentsMutation_VariablesAdapter_instance3i8c5cz7hcsqp as SavePairAssignmentsMutation_VariablesAdapter_instance } from './adapter/SavePairAssignmentsMutation_VariablesAdapter.mjs';
import { Mutationkenyz0l5btz as Mutation } from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Mutation.mjs';
import { ApolloAdaptableWith1g871415y7ifs as ApolloAdaptableWith } from '../../../../../../apollo-kotlin-apollo-annotations/com/apollographql/apollo/annotations/ApolloAdaptableWith.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var DataClass;
function Data() {
  if (DataClass === VOID) {
    class $ {
      constructor(savePairAssignments) {
        this.r6s_1 = savePairAssignments;
      }
      toString() {
        return 'Data(savePairAssignments=' + this.r6s_1 + ')';
      }
      hashCode() {
        return this.r6s_1 == null ? 0 : getBooleanHashCode(this.r6s_1);
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Data()))
          return false;
        if (!(this.r6s_1 == other.r6s_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'Data', VOID, VOID, VOID, VOID, VOID, {1: Data_getInstance});
    DataClass = $;
  }
  return DataClass;
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance = this;
        this.s6s_1 = obj(Data_getInstance());
        this.t6s_1 = (new (Builder())('data', Companion_getInstance().x6p_1)).q47(SavePairAssignmentsMutationSelections_getInstance().w6s_1).l38();
        this.u6s_1 = 'b177b922ea7e084a060efcefb01d21964d1902cda25617294c2e1bcfe587b840';
        this.v6s_1 = 'savePairAssignments';
      }
      a6q() {
        return 'mutation savePairAssignments($input: SavePairAssignmentsInput!) { savePairAssignments(input: $input) }';
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance_0() {
  if (Companion_instance === VOID)
    new (Companion())();
  return Companion_instance;
}
var SavePairAssignmentsMutationClass;
function SavePairAssignmentsMutation() {
  if (SavePairAssignmentsMutationClass === VOID) {
    class $ {
      constructor(input) {
        Companion_getInstance_0();
        this.x6s_1 = input;
      }
      c6q() {
        return 'b177b922ea7e084a060efcefb01d21964d1902cda25617294c2e1bcfe587b840';
      }
      operationId() {
        return this.c6q();
      }
      i4b() {
        return Companion_getInstance_0().a6q();
      }
      d6q() {
        return 'savePairAssignments';
      }
      operationName() {
        return this.d6q();
      }
      n4a(writer, customScalarAdapters, withDefaultValues) {
        SavePairAssignmentsMutation_VariablesAdapter_instance.y6s(writer, this, customScalarAdapters, withDefaultValues);
      }
      m4a() {
        return Companion_getInstance_0().s6s_1;
      }
      toString() {
        return 'SavePairAssignmentsMutation(input=' + this.x6s_1.toString() + ')';
      }
      hashCode() {
        return this.x6s_1.hashCode();
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof SavePairAssignmentsMutation()))
          return false;
        if (!this.x6s_1.equals(other.x6s_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'SavePairAssignmentsMutation', VOID, VOID, [Mutation()]);
    SavePairAssignmentsMutationClass = $;
  }
  return SavePairAssignmentsMutationClass;
}
//region block: exports
export {
  Data as Data2n9h8mazd823k,
  SavePairAssignmentsMutation as SavePairAssignmentsMutation1xoyawurksq0m,
};
//endregion

//# sourceMappingURL=SavePairAssignmentsMutation.mjs.map
